import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import LinearProgress from "@mui/material/LinearProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
export default function LoadingDataAlert() {
	return (
		<Alert
			severity="info"
			color="info"
			sx={{
				"& .MuiAlert-icon": {
					fontSize: 40,
				},
			}}
		>
			<AlertTitle variant="h4">Chargement en cours</AlertTitle>
			<Stack spacing={1}>
				<LinearProgress
					color="info"
					variant="indeterminate"
				/>
				<Typography
					variant="caption"
					color="info"
					fontSize={15}
				>
					Envoie des données en cours . . .
				</Typography>
			</Stack>
		</Alert>
	);
}
